export default "__VITE_ASSET__DarTc14w__ 400w, __VITE_ASSET__BZl9eQZX__ 800w, __VITE_ASSET__gC$lXbvi__ 1200w";